const mutations = {
  showDialog(state) {
    state.dialog = true;
  },

  hideDialog(state) {
    state.dialog = false;
  },

  setModel(state, model) {
    state.errorArray = [];
    state.uCurricularCarrera = model;
  },

  setModels(state, data) {
    state.uCurricularCarreras = data.models;
    state.pagination.totalCount = +data.headers["x-pagination-total-count"];
  },

  setPorCarrera(state, models) {
    state.materiasPorCarrera = models;
  },

  addModel(state, model) {
    state.uCurricularCarreras.unshift(model);
  },

  delModel(state, id) {
    const removeIndex = state.uCurricularCarreras
      .map(function (item) {
        return item.id;
      })
      .indexOf(id);
    state.uCurricularCarreras.splice(removeIndex, 1);
  },

  setErrors(state, errors) {
    state.errorArray = errors;
  },

  setFields(state, data) {
    state.fields = data.fields;
    state.emptyModel = data.model;
  },
};

export default mutations;
